<template>
  <div class="layout-basicLayout">
    <div class="basicLayout-content">
      <router-view/>
    </div>
    <van-tabbar v-model="active" route v-if="$route.meta.tabBar === true" :fixed="false"  active-color="#1296d" inactive-color="#545454">
      <van-tabbar-item v-for="item in $router.getRoutes()" v-if="item.meta.tabBar === true" :to="item.path" :key="item.id">
        <template #icon="props">
          <img :src="props.active ? item.meta.icon : item.meta.select_icon" />
        </template>
        {{item.meta.title}}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "BasicLayout",
  data() {
    return {
      active: 0,
    };
  },
}
</script>

<style lang="scss" scoped>
.layout-basicLayout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 600px;
  margin: auto;

  .basicLayout-content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>